export default __webpack_public_path__ + "static/media/empty.528d295e.png";